/** The launch splash in index.html (black, the star) fades once the app has a screen to show, so launch reads as logo then Home rather than black then Home (F5). */
export function hideSplash() {
  const el = document.getElementById('splash')
  if (!el) return
  el.classList.add('gone')
  window.setTimeout(() => el.remove(), 320)
}
